import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hotels-search-card-info-main" }
const _hoisted_2 = { class: "hotels-search-card-info-main-time" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", { class: "hotels-search-card-info-main-time__title" }, "Заезд", -1)
const _hoisted_4 = { class: "hotels-search-card-info-main-time__date-wrapper" }
const _hoisted_5 = { class: "hotels-search-card-info-main-time__date" }
const _hoisted_6 = { class: "hotels-search-card-info-main-time__day" }
const _hoisted_7 = { class: "hotels-search-card-info-main-time__time" }
const _hoisted_8 = { class: "hotels-search-card-info-main-time" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h4", { class: "hotels-search-card-info-main-time__title" }, "Выезд", -1)
const _hoisted_10 = { class: "hotels-search-card-info-main-time__date-wrapper" }
const _hoisted_11 = { class: "hotels-search-card-info-main-time__date" }
const _hoisted_12 = { class: "hotels-search-card-info-main-time__day" }
const _hoisted_13 = { class: "hotels-search-card-info-main-time__time" }
const _hoisted_14 = { class: "hotels-search-card-info-main-address" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h4", { class: "hotels-search-card-info-main-time__title" }, "Информация", -1)
const _hoisted_16 = { class: "hotels-search-card-info-main-address__text" }
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("h4", _hoisted_5, _toDisplayString(_ctx.parseDate(_ctx.dateIn, "DD MMM")), 1),
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.parseDate(_ctx.dateIn, "dddd")), 1)
      ]),
      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.timeIn), 1)
    ]),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode("div", _hoisted_10, [
        _createVNode("h4", _hoisted_11, _toDisplayString(_ctx.parseDate(_ctx.dateOut, "DD MMM")), 1),
        _createVNode("span", _hoisted_12, _toDisplayString(_ctx.parseDate(_ctx.dateOut, "dddd")), 1)
      ]),
      _createVNode("p", _hoisted_13, _toDisplayString(_ctx.timeOut), 1)
    ]),
    _createVNode("div", _hoisted_14, [
      _hoisted_15,
      _createVNode("p", _hoisted_16, [
        _createTextVNode(_toDisplayString(_ctx.addres) + " ", 1 /* TEXT */),
        _hoisted_17,
        _createTextVNode(" " + _toDisplayString(_ctx.phone), 1 /* TEXT */)
      ])
    ])
  ]))
}